import { render } from "./FilterDistributorOI.vue?vue&type=template&id=417e93b8"
import script from "./FilterDistributorOI.vue?vue&type=script&lang=js"
export * from "./FilterDistributorOI.vue?vue&type=script&lang=js"
script.render = render

export default script